<div
  class="d-flex"
  dropdown
  (click)="$event.stopPropagation()"
  container="body"
  style="align-items: center"
>
  <div class="d-flex d-lg-none fs-12px fc-muted" style="padding-right: 6px">
    <span
      class="d-inline-block ml-1 cursor-pointer lh-12px fc-muted align-middle"
      matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
      mat-raised-button
      #tooltip="matTooltip"
      [matTooltip]="
        globalVars.convertTstampToDateTime(postContent.TimestampNanos)
      "
      >{{
        globalVars.convertTstampToDaysOrHours(postContent.TimestampNanos)
      }}</span
    >
  </div>
  <a
    class="js-feed-post__dropdown-toggle link--unstyled text-grey9"
    role="button"
    dropdownToggle
  >
    <i class="fas fa-ellipsis-h"></i>
  </a>
  <div
    class="dropdown-menu dropdown-menu-right p-0 border background-color-light-grey"
    *dropdownMenu
  >
    <a
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item"
      (click)="copyPostLinkToClipboard($event)"
    >
      <i class="icon-link"></i>
      Link to {{ post.IsNFT ? 'NFT' : 'Post' }}
    </a>
    <a
      *ngIf="showSharePost"
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item"
      (click)="sharePostUrl($event)"
    >
      <i class="fas fa-share-square"></i>
      Share {{ post.IsNFT ? 'NFT' : 'Post' }}
    </a>
    <a
      *ngIf="
        globalVars.loggedInUser.PublicKeyBase58Check ===
          post.PosterPublicKeyBase58Check &&
        !post.IsNFT &&
        !post.ParentStakeID
      "
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item text-success"
      (click)="openMintNftModal($event)"
    >
      <i class="fas fa-stamp"></i>
      Mint NFT
    </a>
    <a
      *ngIf="showCreateNFTAuction()"
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item text-success"
      (click)="openCreateNFTAuctionModal($event)"
    >
      <i class="fas fa-dollar-sign"></i>
      Put On Sale
    </a>
    <a
      *ngIf="showTransferNFT()"
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item"
      (click)="openTransferNFTModal($event)"
    >
      <i class="fas fa-paper-plane"></i>
      Transfer NFT
    </a>
    <a
      *ngIf="showBurnNFT()"
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item"
      (click)="openBurnNFTModal($event)"
    >
      <i class="fa fa-fire"></i>
      Burn NFT
    </a>
    <a
      *ngIf="post.IsNFT && globalVars.showAdminTools()"
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item text-success"
      (click)="dropNFT()"
    >
      <i class="fas fa-tint"></i>
      Add NFT to drop
    </a>
    <a
      *ngIf="post.InMempool"
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item"
      style="cursor: default"
    >
      <i class="fas fa-spinner"></i>
      Status: Mining...
    </a>
    <a
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item text-danger"
      (click)="reportPost()"
    >
      <i class="fas fa-flag"></i>
      Report Content
    </a>
    <a
      *ngIf="showHidePostDropdownItem()"
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item text-danger"
      (click)="hidePost()"
    >
      <i class="fas fa-trash"></i>
      Hide
    </a>
    <a
      *ngIf="showBlockUserDropdownItem()"
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item text-danger"
      (click)="blockUser()"
    >
      <i class="fas fa-ban"></i>
      Block User
    </a>
    <a
      *ngIf="globalVars.showSuperAdminTools()"
      class="dropdown-menu-item fs-12px d-block link--unstyled p-10px feed-post__dropdown-menu-item"
      (click)="addMultiplier()"
    >
      <i class="fa fa-sort-amount-asc"></i>
      Feed Multiplier
    </a>
    <a
      *ngIf="showAddToGlobalFeedDropdownItem()"
      class="dropdown-menu-item d-block link--unstyled p-10px feed-post__dropdown-menu-item text-success fs-12px"
      (click)="_addPostToGlobalFeed($event)"
    >
      <i class="fas fa-folder-plus"></i>
      Add To Feed
    </a>
    <a
      *ngIf="showRemoveFromGlobalFeedDropdownItem()"
      class="dropdown-menu-item d-block link--unstyled p-10px feed-post__dropdown-menu-item text-danger fs-12px"
      (click)="_addPostToGlobalFeed($event)"
    >
      <i class="fas fa-folder-minus"></i>
      Remove From Feed
    </a>
    <a
      *ngIf="showPinPostToGlobalFeedDropdownItem()"
      class="dropdown-menu-item d-block link--unstyled p-10px feed-post__dropdown-menu-item text-success fs-12px"
      (click)="_pinPostToGlobalFeed($event)"
    >
      <i class="fas fa-thumbtack"></i>
      Pin To Feed
    </a>
    <a
      *ngIf="showUnpinPostFromGlobalFeedDropdownItem()"
      class="dropdown-menu-item d-block link--unstyled p-10px feed-post__dropdown-menu-item text-danger fs-12px"
      (click)="_pinPostToGlobalFeed($event)"
    >
      <i class="fas fa-undo"></i>
      Unpin From Feed
    </a>
  </div>
</div>
